import { useEffect, useState } from "react";

import dayjs from "dayjs";

const useStartDate = () => {
  const [start, setStart] = useState(undefined);

  useEffect(() => {
    const FOUR_WEEKS_AGO = 2678400;
    const today = dayjs().unix();
    const todayFixed = dayjs.unix(today).hour(0).minute(0).second(0).unix();
    const startDate = todayFixed - FOUR_WEEKS_AGO;
    setStart(startDate);
  }, []);

  return { start };
};

export default useStartDate;
